import { Module } from 'vuex'
import { IRootState } from '@/store/types'
import {
    BlocksState,
    EVMBlockQueryResponse,
    RawEVMBlockResponse,
} from './models'
import {
    getEVMBlock,
    IEVMBlockParam,
    getEVMLatestBlock,
    getEVMBlockByHexHttp,
} from '@/services/evmblocks'
import { parseEVMBlocks } from './helpers/parseEVMBlocks'
import {
    DEFAULT_NETWORK,
    CURRENT_SUBNET,
    subnet_wss_url,
} from '../network/network'

const defaultState = {
    latestBlockNumber: null,
    evmBlock: null,
    evmBlocks: [],
    fetching: false,
    socket:
        // window.location.href.includes('blockchain') ||
        // localStorage.getItem('isTSP')
        CURRENT_SUBNET !== null
            ? new WebSocket(
                  //   'wss://subnet-goldcoast.dcomm.network/ext/bc/2JFccSuMrJJLMmiEEMAvBs9Nc8M8vZBSomTpGiEJ6iTdJpZJbs/ws'
                  subnet_wss_url
              )
            : new WebSocket(DEFAULT_NETWORK.wsUrl),
    rawBlockDetails: [],
    latestBlockDetail: null,
}
const blocks_module: Module<BlocksState, IRootState> = {
    namespaced: true,
    modules: {},
    state: defaultState,
    mutations: {
        addLatestBlock(state, block: string) {
            state.latestBlockNumber = block
        },
        addEVMBlock(state, block) {
            state.evmBlock = block
            state.fetching = false
        },
        addLatestBlockDetail(state, block) {
            state.latestBlockDetail = block
            state.fetching = false
        },
        addEVMBlocks(state, blocks: EVMBlockQueryResponse[]) {
            state.evmBlocks = blocks
            state.fetching = false
        },
        fetching(state, value: boolean) {
            state.fetching = value
        },
        updateMessage(state, message) {
            state.rawBlockDetails = message
        },
        newConnection(state, data) {
            state.socket = data
        },
    },
    actions: {
        // async sendMessage(store, data) {
        //     const socket = store.state.socket
        //     if (socket.readyState === WebSocket.OPEN) {
        //         socket.send(data)
        //     } else if (socket.readyState === WebSocket.CONNECTING) {
        //         console.log('WebSocket is connecting, trying again in 500ms...')
        //         setTimeout(() => socket.send(data), 1000)
        //     } else {
        //         store.dispatch('Blocks/connect')
        //     }
        // },
        sendMessage({ state, dispatch }, message) {
            dispatch('waitForConnection', {
                callback: () => {
                    state.socket.send(message)
                },
                interval: 1000,
            })
        },
        waitForConnection({ state, dispatch }, { callback, interval }) {
            if (state.socket.readyState === 1) {
                callback()
            } else {
                setTimeout(() => {
                    dispatch('waitForConnection', { callback, interval })
                }, interval)
            }
        },
        async init({ dispatch }) {
            await dispatch('updateLatestBlock')
        },
        async connect(store) {
            const data =
                CURRENT_SUBNET !== null
                    ? new WebSocket(subnet_wss_url)
                    : new WebSocket(DEFAULT_NETWORK.wsUrl)
            store.commit('newConnection', data)
        },
        async updateLatestBlock(store) {
            const latestBlockRes: string = await getEVMLatestBlock().then(
                (res) => res.data.result as string
            )

            const blockNumber = parseInt(latestBlockRes, 16).toString()
            store.commit('addLatestBlock', blockNumber)
            localStorage.setItem('latestBlock', blockNumber)
            //for websocket call.
            // store.state.socket.addEventListener('message', function (event) {
            //     const data: any = { data: JSON.parse(event.data) }
            //     debugger
            //     latestBlock = data.data.result.number
            //     const blockNumber = parseInt(latestBlock, 16).toString()
            //     store.commit('addLatestBlock', blockNumber)
            // })
            const data = await getEVMBlockByHexHttp(blockNumber)
            const rawBlockData: RawEVMBlockResponse = data.data.result

            const parsedBlock: EVMBlockQueryResponse = {
                ...rawBlockData,
                blockNumber: parseInt(rawBlockData.number, 16).toString(),
                header: {
                    ...rawBlockData,
                },
            }
            const blockRes = parsedBlock
            if (blockRes) {
                const parsedBlock = parseEVMBlocks(blockRes)
                store.commit('addLatestBlockDetail', parsedBlock)
            }
        },
        async getEVMBlock(store, payload: IEVMBlockParam) {
            store.commit('fetching', true)

            await getEVMBlock(payload)

            store.state.socket.addEventListener('message', function (event) {
                const data: any = { data: JSON.parse(event.data) }
                const blockData = data
                // store.commit('updateMessage', blockData)
                const rawBlockData: RawEVMBlockResponse = blockData.data.result

                const parsedBlock: EVMBlockQueryResponse = {
                    ...rawBlockData,
                    blockNumber: parseInt(rawBlockData.number, 16).toString(),
                    header: {
                        ...rawBlockData,
                    },
                }
                const blockRes = parsedBlock
                if (blockRes) {
                    const parsedBlock = parseEVMBlocks(blockRes)
                    store.commit('addEVMBlock', parsedBlock)
                }
            })
            store.commit('fetching', true)
        },
        async getEVMBlocks(
            store,
            param: {
                top: number
                bottom: number
            }
        ) {
            const blocks: EVMBlockQueryResponse[] = []
            store.commit('fetching', true)
            for (let i = param.top; i > param.bottom; --i) {
                await getEVMBlock({ height: i.toString() }, true)
            }
            store.state.socket.addEventListener('message', function (event) {
                const data: any = { data: JSON.parse(event.data) }
                const blockData = data
                const rawBlockData: RawEVMBlockResponse = blockData.data.result

                const parsedBlock: EVMBlockQueryResponse = {
                    ...rawBlockData,
                    blockNumber: parseInt(rawBlockData.number, 16).toString(),
                    header: {
                        ...rawBlockData,
                    },
                }
                const block = parseEVMBlocks(parsedBlock)
                blocks.push(block)
            })
            blocks.sort((a, b) => {
                return parseInt(b.blockNumber) - parseInt(a.blockNumber)
            })
            store.commit('addEVMBlocks', blocks)
            store.commit('fetching', false)
        },
        addEVMBlock(store, block) {
            store.commit('addEVMBlock', block)
        },
        addEVMBlocks(store, blocks: EVMBlockQueryResponse[]) {
            store.commit('addEVMBlocks', blocks)
        },
    },
}

export default blocks_module
